import {Component, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-table-layout",
    imports: [],
    templateUrl: "./table-layout.component.html",
    styleUrl: "./table-layout.component.scss",
})
export class TableLayoutComponent {}
